const PickerClasses = {
  DatePickerClasses: {
    container: 'day-picker',
    wrapper: 'day-picker__wrapper',
    interactionDisabled: 'day-picker--interaction-disabled',
    months: 'day-picker__months',
    month: 'day-picker__month',
    navBar: 'day-picker__nav-bar',
    navButtonPrev: 'day-picker__nav-button day-picker__nav-button--prev',
    navButtonNext: 'day-picker__nav-button day-picker__nav-button--next',
    navButtonInteractionDisabled: 'day-picker__nav-button--interaction-disabled',
    caption: 'day-picker__caption',
    weekdays: 'day-picker__weekdays',
    weekdaysRow: 'day-picker__weekdays-row',
    weekday: 'day-picker__weekday',
    body: 'day-picker__body',
    week: 'day-picker__week',
    weekNumber: 'day-picker__week-number',
    day: 'day-picker__day',
    footer: 'day-picker__footer',
    todayButton: 'day-picker__today-button',
    today: 'day-picker__day--today',
    selected: 'day-picker__day--selected',
    disabled: 'day-picker__day--disabled',
    outside: 'day-picker__day--outside',
  },

  PickerInput: {
    container: 'day-picker__input',
    overlayWrapper: 'day-picker__input-overlay-wrapper',
    overlay: 'day-picker__input-overlay',
  },
}

export default PickerClasses
